export const STORAGE_KEYS = {
  TOKEN: 'Authorization',
  ORGUUID: 'ORGUUID',
  REFRESH_TOKEN: 'RefreshToken',
  CSRF_TOKEN: 'CsrfToken',
  REDIRECT_AFTER_LOGIN: 'redirect_after_login',
  QUICK_START_FORM_DATA: 'quickStartFormData',
  QUICK_START_ORDER_ID: 'quickStartOrderId',
} as const;
